<template>
  <button
    class="btn"
    :class="btnClass"
    v-on="$listeners">
    <img
      src="@/assets/images/btn_today.svg"
      class="today-btn-img"
      :style="btnImgStyle">
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    xl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    btnClass() {
      const arrayClass = ['today-btn']
      if (this.xl) arrayClass.push('today-btn--xl')
      if (this.active) arrayClass.push('today-btn--active')
      return arrayClass
    },
    btnImgStyle() {
      if (this.xl) return {width: '60px'}
      return {width: '45px'}
    }
  },
}
</script>

<style scoped lang="scss">
.today-btn{
  position: relative;
  background-color: $l-blue;
  box-shadow: 1px 2px 6px $grey05;
  border-radius: 50%;
  border: none;
  width: 60px;
  height: 60px;

  &--active{
    background-color: $blue;
  }

  &:active {
    background-color: $blue;
  }
}

.today-btn--xl {
  width: 80px;
  height: 80px;
}

.today-btn-img {
  height: auto;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 40%;
}
</style>